import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@cotera/client/v0/components/ui/toggle-group';
import type { LibraryViewMode } from './folder-contents-page.model';

/**
 * Rows vs cards.
 *
 * Sits at the right end of the filter band, which is where Drive and Figma put
 * the same control. It was briefly moved up into the toolbar on the theory that
 * view mode groups with sort — but the toolbar shares its row with the page
 * title, so it has less room to give than the band does, and the move just
 * relocated the crowding.
 */
export const LibraryViewToggle: React.FC<{
  viewMode: LibraryViewMode;
  onViewModeChange: (value: LibraryViewMode) => void;
}> = ({ viewMode, onViewModeChange }) => (
  <ToggleGroup
    type="single"
    variant="outline"
    size="sm"
    spacing={1}
    orientation="horizontal"
    value={viewMode}
    onValueChange={(value) => {
      // Radix emits '' when the active item is re-clicked; ignore it so the
      // view can't be toggled into no mode at all.
      if (value === 'list' || value === 'grid') {
        onViewModeChange(value);
      }
    }}
    aria-label="View mode"
  >
    <ToggleGroupItem value="list" aria-label="List view">
      <List className="h-4 w-4" />
    </ToggleGroupItem>
    <ToggleGroupItem value="grid" aria-label="Grid view">
      <LayoutGrid className="h-4 w-4" />
    </ToggleGroupItem>
  </ToggleGroup>
);
